import { FactoryProvider, Optional } from '@angular/core';
import { LoggingService } from '../config/logging.service';
import { LocalstorageService } from '../config/localstorage.service';

export function loggingServiceFactory(optionalService: LoggingService): LoggingService {
  return optionalService || new LoggingService(new LocalstorageService());
}

export const LOGGING_SERVICE_PROVIDER: FactoryProvider = {
  provide: LoggingService,
  useFactory: loggingServiceFactory,
  deps: [[new Optional(), LoggingService]]
};
